import { JobFilterData } from "../../../Constant";
import { useState } from "react";
import Filter from "./Filter";
import { Btn } from "../../../AbstractElements";
import Location from "./Location";
import JobTitleClass from "./JobTitle";
import Industry from "./Industry";
import SkillClass from "./Skill";

const Sidebar = () => {
  const [filterToggle, setFilterToggle] = useState(false);
  const toggle = () => setFilterToggle(!filterToggle);

  return (
    <>
      <Btn color="primary" className="email-aside-toggle md-sidebar-toggle" onClick={toggle}>{JobFilterData}</Btn>
      <div className={`md-sidebar-aside job-sidebar ${filterToggle ? "open" : ""}`}>
        <div className="default-according style-1 faq-accordion job-accordion">
          <Filter />
          <Location />
          <JobTitleClass />
          <Industry />
          <SkillClass />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
